export default __webpack_public_path__ + "assets/backgroundFlights.svg";